const validateFile = (
  file,
  maxSizeMB = 2,
  allowedTypes = [
    "application/pdf",
    "image/jpeg",
    "image/png",
  ]
) => {
  if (!file) {
    return {
      valid: false,
      message: "Please select a file.",
    };
  }
 
  // File type validation
  if (!allowedTypes.includes(file.type)) {
    return {
      valid: false,
      message: "Only PDF, JPG, JPEG, and PNG files are allowed.",
    };
  }
 
  // File size validation
  const maxSizeBytes = maxSizeMB * 1024 * 1024;
 
  if (file.size > maxSizeBytes) {
    return {
      valid: false,
      message: `File size must not exceed ${maxSizeMB} MB.`,
    };
  }
 
  return {
    valid: true,
    message: "",
  };
};
 
export default validateFile;